__turbopack_context__.v({
  "avatar": "Avatars-module__ADpFiW__avatar",
  "container": "Avatars-module__ADpFiW__container",
  "genericPlaceholder": "Avatars-module__ADpFiW__genericPlaceholder",
  "genericRow": "Avatars-module__ADpFiW__genericRow",
  "grid": "Avatars-module__ADpFiW__grid",
  "initials": "Avatars-module__ADpFiW__initials",
  "initialsLarge": "Avatars-module__ADpFiW__initialsLarge",
  "noHover": "Avatars-module__ADpFiW__noHover",
  "primaryCard": "Avatars-module__ADpFiW__primaryCard",
  "primaryGenderAge": "Avatars-module__ADpFiW__primaryGenderAge",
  "primaryLeft": "Avatars-module__ADpFiW__primaryLeft",
  "primaryMeta": "Avatars-module__ADpFiW__primaryMeta",
  "primaryName": "Avatars-module__ADpFiW__primaryName",
  "primaryRole": "Avatars-module__ADpFiW__primaryRole",
  "primarySummary": "Avatars-module__ADpFiW__primarySummary",
  "sectionTitle": "Avatars-module__ADpFiW__sectionTitle",
  "smallCards": "Avatars-module__ADpFiW__smallCards",
});
